export default {
  app: {
    searchNotData: 'No search results yet',
    toSearch: 'to search',
    toNavigate: 'to navigate',
  },
  countdown: {
    normalText: 'Get SMS code',
    sendText: 'Reacquire in {0}s',
  },
  cropper: {
    selectImage: 'Select Image',
    uploadSuccess: 'Uploaded success!',
    modalTitle: 'Avatar upload',
    okText: 'Confirm and upload',
    btn_reset: 'Reset',
    btn_rotate_left: 'Counterclockwise rotation',
    btn_rotate_right: 'Clockwise rotation',
    btn_scale_x: 'Flip horizontal',
    btn_scale_y: 'Flip vertical',
    btn_zoom_in: 'Zoom in',
    btn_zoom_out: 'Zoom out',
    preview: 'Preivew',
  },
  drawer: {
    loadingText: 'Loading...',
    cancelText: 'Close',
    okText: 'Confirm',
  },
  excel: {
    exportModalTitle: 'Export data',
    fileType: 'File type',
    fileName: 'File name',
  },
  form: {
    putAway: 'Put away',
    unfold: 'Unfold',
    maxTip: 'The number of characters should be less than {0}',
    apiSelectNotFound: 'Wait for data loading to complete...',
  },
  icon: {
    placeholder: 'Click the select icon',
    search: 'Search icon',
    copy: 'Copy icon successfully!',
  },
  menu: {
    search: 'Menu search',
  },
  modal: {
    cancelText: 'Close',
    okText: 'Confirm',
    close: 'Close',
    maximize: 'Maximize',
    restore: 'Restore',
  },
  table: {
    settingDens: 'Density',
    settingDensDefault: 'Default',
    settingDensMiddle: 'Middle',
    settingDensSmall: 'Compact',
    settingColumn: 'Column settings',
    settingColumnShow: 'Column display',
    settingIndexColumnShow: 'Index Column',
    settingSelectColumnShow: 'Selection Column',
    settingFixedLeft: 'Fixed Left',
    settingFixedRight: 'Fixed Right',
    settingFullScreen: 'Full Screen',
    index: 'Index',
    total: 'total of {total}',
  },
  time: {
    before: ' ago',
    after: ' after',
    just: 'just now',
    seconds: ' seconds',
    minutes: ' minutes',
    hours: ' hours',
    days: ' days',
  },
  tree: {
    selectAll: 'Select All',
    unSelectAll: 'Cancel Select',
    expandAll: 'Expand All',
    unExpandAll: 'Collapse all',

    checkStrictly: 'Hierarchical association',
    checkUnStrictly: 'Hierarchical independence',
  },
  upload: {
    save: 'Save',
    upload: 'Upload',
    imgUpload: 'ImageUpload',
    uploaded: 'Uploaded',

    operating: 'Operating',
    del: 'Delete',
    download: 'download',
    saveWarn: 'Please wait for the file to upload and save!',
    saveError: 'There is no file successfully uploaded and cannot be saved!',

    preview: 'Preview',
    choose: 'Select the file',

    accept: 'Support {0} format',
    acceptUpload: 'Only upload files in {0} format',
    maxSize: 'A single file does not exceed {0}MB ',
    maxSizeMultiple: 'Only upload files up to {0}MB!',
    maxNumber: 'Only upload up to {0} files',

    legend: 'Legend',
    fileName: 'File name',
    fileSize: 'File size',
    fileStatue: 'File status',

    startUpload: 'Start upload',
    uploadSuccess: 'Upload successfully',
    uploadError: 'Upload failed',
    uploading: 'Uploading',
    uploadWait: 'Please wait for the file upload to finish',
    reUploadFailed: 'Re-upload failed files',
  },
  verify: {
    error: 'verification failed！',
    time: 'The verification is successful and it takes {time} seconds！',
    redoTip: 'Click the picture to refresh',
    dragText: 'Hold down the slider and drag',
    successText: 'Verified',
  },
  msg:{
    '提示1：请设置显示纬度':'Tip 1: please set the display latitude',
    "提示2：请设置显示经度":'Tip 2: please set the display longitude',
    '还未设计系统门户首页，请设计相应门户':'The home page of the system portal has not been designed yet. Please design the corresponding portal.',
    '联系管理员':'Contact the administrator',
    '用户权限异常, 请联系系统管理人员':'User permissions are abnormal, please contact the system administrator',
    '服务端错误, 状态码':'Server error, status code',
    '未知的异常, 状态码':'Unknown exception, status code',
    '请联系系统管理人员':'Please contact the system administrator',
    '操作失败':'Operation failed'
    
  },
  password:{
    '密码修改':'Password modification',
    '修改当前用户密码':'Modify the current user password',
    '修改成功后会自动退出当前登录！':'The current login will be logged out automatically after the modification is successful!',
    '当前密码':'Current Pwd',
    '新密码':'New Pwd',
    '确认密码':'Confirm Pwd',
    '请输入新密码':'Please enter a new password',
    '密码不能为空':'Password cannot be empty',  
    '重置':'Reset',
    '确认':'OK',
    '修改密码成功':'Password changed successfully',
    '两次输入的密码不一致!':'The passwords entered two times are not the same!'
  }
};
